export default "__VITE_ASSET__9cZvjeFG__"